import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Download, BookOpen, FileText } from 'lucide-react';

const GuideSection = () => {
  const [formData, setFormData] = useState({ name: '', email: '', mobile: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Guide download request submitted
    alert('Thank you! Your guide will be sent to your email shortly.');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side - Guide 1 */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-300 hover:-translate-y-2">
            <div className="bg-gradient-to-r from-[#6B1B4D] to-[#DC143C] p-8 text-white">
              <BookOpen className="mb-4" size={48} />
              <h3 className="text-3xl font-bold mb-2">The UAE Business Setup Guide 2025</h3>
              <p className="text-lg opacity-90">Complete step-by-step procedures</p>
            </div>
            <div className="p-8">
              <p className="text-gray-600 mb-6 leading-relaxed">
                Discover the step-by-step procedures and essential considerations you need to know before setting up a company in the UAE. Get valuable insights and learn all the know-how to ensure a successful business journey.
              </p>
              <ul className="space-y-3 mb-6 text-gray-700">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#DC143C] rounded-full"></div>
                  Company Registration Process
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#DC143C] rounded-full"></div>
                  Legal & Compliance Requirements
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#DC143C] rounded-full"></div>
                  UAE Tax Structure & Benefits
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#DC143C] rounded-full"></div>
                  Banking & Visa Setup
                </li>
              </ul>
              <Button className="w-full bg-gradient-to-r from-[#6B1B4D] to-[#DC143C] text-white hover:shadow-lg transition-all group">
                <Download className="mr-2" size={20} />
                Download Free Guide
              </Button>
            </div>
          </div>

          {/* Right Side - Guide 2 with Form */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-300 hover:-translate-y-2">
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-8 text-white">
              <FileText className="mb-4" size={48} />
              <h3 className="text-3xl font-bold mb-2">The UAE Corporate Tax & VAT Guide 2025</h3>
              <p className="text-lg opacity-90">Everything you need to know</p>
            </div>
            <div className="p-8">
              <p className="text-gray-600 mb-6 leading-relaxed">
                The comprehensive guide covers everything from understanding UAE tax regulations to optimizing tax strategies. Ensure you stay ahead and protect your business from potential penalties.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="name" className="text-gray-700">Name</Label>
                  <Input
                    id="name"
                    type="text"
                    placeholder="Your full name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label htmlFor="email" className="text-gray-700">Work Email</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label htmlFor="mobile" className="text-gray-700">Mobile</Label>
                  <Input
                    id="mobile"
                    type="tel"
                    placeholder="+971 52 866 2076"
                    value={formData.mobile}
                    onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                    required
                    className="mt-1"
                  />
                </div>
                <Button 
                  type="submit"
                  className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white hover:shadow-lg transition-all"
                >
                  Download Now
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuideSection;